<template>
  <hi-sub-page>
    <template v-if="campaignId">
      <hi-page-column card grow>
        <template v-slot:header> Opened ({{ opened.length }}) </template>
        <hi-row v-for="msg in opened" :key="msg.id" separator>
          <b
            ><di-details :lead-id="msg.uid">{{ msg.to.name }}</di-details> - </b
          >{{ msg.to.email }}
          <span v-if="msg.tracking.open.length < 2" class="ui-text-italic"
            >({{ msg.lastOpened | timestamp(true) }})</span
          >
          <div v-if="msg.tracking.open.length > 1">
            <div
              style="padding-left:50px"
              class="ui-text"
              v-for="open in msg.tracking.open"
              :key="open.timestamp.seconds"
            >
              {{ open.timestamp | timestamp(true) }}
            </div>
          </div>
        </hi-row>
      </hi-page-column>
      <hi-page-column card grow>
        <template v-slot:header> Clicked ({{ clicked.length }}) </template>
        <hi-row v-for="msg in clicked" :key="msg.id" separator>
          <b
            ><di-details :lead-id="msg.uid">{{ msg.to.name }}</di-details> - </b
          >{{ msg.to.email }}
          <div
            style="padding-left:50px"
            class="ui-text"
            v-for="click in clickedUrls(msg)"
            :key="click.url + Math.random()"
          >
            {{ click.timestamp | timestamp(true) }} - {{ click.url }}
          </div>
        </hi-row>
      </hi-page-column>
      <hi-page-column card width="25%">
        <template v-slot:header> Failed ({{ failed.length }}) </template>
        <hi-row v-for="msg in failed" :key="msg.id" separator>
          <b
            ><di-details :lead-id="msg.uid">{{ msg.to.name }}</di-details> - </b
          >{{ msg.to.email }}
          <span class="ui-text-italic"
            >({{ msg.dateUpdated | timestamp(true) }})</span
          >
          <div class="ui-text">Reason: {{ msg.failedReason || "unknown" }}</div>
        </hi-row>
      </hi-page-column>
    </template>
  </hi-sub-page>
</template>

<script>
import HiSubPage from "@/components/scaffold/HiSubPage";
import HiPageColumn from "@/components/scaffold/HiPageColumn";
import { db } from "@/db";
import HiRow from "@/components/scaffold/HiRow";
import DiDetails from "@/components/edm/DiDetails";
export default {
  name: "EdmStatView",
  components: { DiDetails, HiRow, HiSubPage, HiPageColumn },
  created() {
    console.log("statView created");
  },
  props: {
    // campaignId: {
    //   type: String
    // }
  },
  data() {
    return {
      messages: {},
      campaignId: null
    };
  },
  firestore() {
    return {
      messages: db
        .collection("emails/data/messages")
        .where("category", "==", "campaign")
        .where("tag", "==", this.campaignId)
    };
  },
  methods: {
    clickedUrls(msg) {
      const tracking = msg.tracking;
      if (!tracking || !tracking.click) return null;
      return tracking.click;
    }
  },
  computed: {
    delivered() {
      return this.messages.filter(
        message => message.tracking && message.tracking.delivered
      );
    },
    opened() {
      return this.messages
        .filter(
          message =>
            message.tracking &&
            message.tracking.open &&
            message.tracking.open.length
        )
        .sort((m1, m2) => {
          // console.log(m1);
          // console.log(m1.lastOpened.seconds, m2.lastOpened.sends);
          return m2.dateUpdated.seconds - m1.dateUpdated.seconds;
        });
    },
    clicked() {
      return this.messages
        .filter(message => message.lastClicked != null)
        .sort((m1, m2) => {
          // console.log(m1.lastOpened.seconds, m2.lastOpened.sends);
          return m2.lastClicked.seconds - m1.lastClicked.seconds;
        });
    },
    failed() {
      return this.messages
        .filter(message => message.status === "failed")
        .sort((m1, m2) => {
          return m2.dateUpdated.seconds - m1.dateUpdated.seconds;
        });
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.params.campaignId) {
          this.campaignId = route.params.campaignId;
          // console.log(this.campaignId);
          // this.$bind(
          //   "messages",
          //   db
          //     .collection("emails/data/messages")
          //     .where("category", "==", "campaign")
          //     .where("tag", "==", this.campaignId)
          // );
        }
      }
    }
  }
};
</script>

<style scoped></style>
